import { formatLocalDateTime } from '../utils/dateTime';

export class TransactionFetchFilter {
    id?: number;
    hashedID?: string;
    record_id?: number;
    start_date?: string;
    end_date?: string;
    transaction_action_id?: number;
    transaction_object_id?: number;
    transaction_indirect_object_id?: number;
    transaction_media_id?: number;
    quantity_min?: number;
    quantity_max?: number;
    amount_min?: number;
    amount_max?: number;
    created_by_user_id?: number; // New field for filtering by user
    limit: number = 20.0;
    page: number = 1.0;
    private static readonly ID_PREFIX = 'txn_';

    constructor() {
        // No default start_date/end_date/amount_min/amount_max — only send to API when user sets filters
    }

    private formatDate(date: Date): string {
        return formatLocalDateTime(date);
    }

    toQueryParams(): Record<string, string> {
        const params: Record<string, string> = {};
        
        if (this.id !== undefined) {
            params.id = this.id.toString();
        }
        if (this.hashedID) {
            params.hashed_id = this.hashedID;
        }
        if (this.record_id !== undefined) {
            params.record_id = this.record_id.toString();
        }
        if (this.start_date) {
            params.start_date = this.start_date;
        }
        if (this.end_date) {
            params.end_date = this.end_date;
        }
        if (this.transaction_action_id !== undefined) {
            params.transaction_action_id = this.transaction_action_id.toString();
        }
        if (this.transaction_object_id !== undefined) {
            params.transaction_object_id = this.transaction_object_id.toString();
        }
        if (this.transaction_indirect_object_id !== undefined) {
            params.transaction_indirect_object_id = this.transaction_indirect_object_id.toString();
        }
        if (this.transaction_media_id !== undefined) {
            params.transaction_media_id = this.transaction_media_id.toString();
        }
        if (this.quantity_min !== undefined) {
            params.quantity_min = this.quantity_min.toString();
        }
        if (this.quantity_max !== undefined) {
            params.quantity_max = this.quantity_max.toString();
        }
        if (this.amount_min !== undefined) {
            params.amount_min = this.amount_min.toString();
        }
        if (this.amount_max !== undefined) {
            params.amount_max = this.amount_max.toString();
        }
        if (this.created_by_user_id !== undefined) {
            params.created_by_user_id = this.created_by_user_id.toString();
        }
        if (this.limit !== undefined) {
            params.limit = this.limit.toString();
        }
        if (this.page !== undefined) {
            params.page = this.page.toString();
        }
        
        return params;
    }
}